import { isTileNode } from '@/components/diagrams/FlowChart/utils/nodes';
import { didTileNotesChange } from '@/components/diagrams/FlowChart/utils/tileNotes';

import { ApplyTileNotesAction, EntityDiagramActionFn } from '../types';

/**
 * Applies AI-generated notes to multiple tiles at once (bulk generate from the
 * selection toolbar). Mirrors the per-tile updateTileConfigAction: sets
 * data.notes and clears the height so the tile re-measures (which also marks
 * the diagram dirty via the resulting node change, matching the single-tile
 * save path).
 */
export const applyTileNotesAction: EntityDiagramActionFn<
  ApplyTileNotesAction
> = (state, action) => {
  const { updates } = action;
  const idsToUpdate = new Set(Object.keys(updates));
  if (idsToUpdate.size === 0) return state;

  const nodes = state.nodes.map((node) => {
    if (!isTileNode(node) || !idsToUpdate.has(node.id)) return node;

    const newNotes = updates[node.id];
    if (typeof newNotes !== 'string') return node;

    const shouldClearHeight = didTileNotesChange(node.data.notes, newNotes);

    return {
      ...node,
      ...(shouldClearHeight && {
        width: node.width,
        height: undefined,
        measured: { width: node.measured?.width, height: undefined },
      }),
      data: {
        ...node.data,
        ...(shouldClearHeight && { dimensionsFinalized: undefined }),
        notes: newNotes,
      },
    };
  });

  return { ...state, nodes };
};
